export class SessionNames {
  static readonly USER_ROLES: string = 'USER_ROLES';
  static readonly ACTIVITY_DATETIME: string = 'ACTIVITY_DATETIME';
}
